import {
  geolocationService,
  isLocationCaptureBlocked,
} from "@/src/modules/core/lib/geolocation-service";
import {isNativeMobileGeolocationPlatform} from "@/src/modules/core/lib/geolocation-platform";

export type VerifyLocationForSheetOptions = {
  /** User tapped "I've enabled location" — always probe, never trust buffer. */
  forceProbe?: boolean;
};

/**
 * Gate for opening coordinate-required sheets.
 *
 * Optimistic by design: open instantly unless we ALREADY know capture is
 * blocked (synchronous state read — no probe). This removes the per-click
 * location probe that delayed every "New" tap.
 *
 * GPS correctness is enforced where it actually matters, not on open:
 *   - in-sheet: `useCoordinatesGate` + `CoordinatesRequiredGate` disable submit
 *   - submit:   `resolveGpsForSubmit` is device-only on mobile (blocks + toasts)
 *
 * `forceProbe` (dialog "I've enabled location") still runs a real recheck.
 */
export async function verifyLocationForRequiredSheet(
  options: VerifyLocationForSheetOptions = {},
): Promise<boolean> {
  // Desktop never hard-blocks on open: it falls back to the property's saved
  // coordinates at submit, so opening is always allowed. Only mobile gates here.
  if (!isNativeMobileGeolocationPlatform()) {
    return true;
  }

  if (options.forceProbe) {
    return geolocationService.recheckLocationForRequiredSheet();
  }

  return !isLocationCaptureBlocked();
}
